import { ShieldAlert } from "lucide-react";

export const DisclaimerBanner = ({ compact }) => (
  <div data-testid="medical-disclaimer"
       className={`flex gap-3 rounded-2xl border border-[#E8907E]/40 bg-[#E8907E]/10 text-[#8a4436] ${compact ? "p-3 text-xs" : "p-4 text-sm"}`}>
    <ShieldAlert strokeWidth={1.8} className="h-5 w-5 shrink-0" />
    <p className="leading-relaxed">
      This is educational information, not medical advice. Always taper under the guidance of a doctor or prescriber.
      <strong> Do not stop benzodiazepines abruptly.</strong>
    </p>
  </div>
);
